// extracted by mini-css-extract-plugin
export default {"container":"legal-footer_container__CHAjn","textContainer":"legal-footer_textContainer__-5rDe"};